var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDnaVisitTypeIconTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    stroke: "#707070",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86193 18.5C7.32116 17.7616 7.58229 16.9512 7.63632 16.1588C7.71736 14.9792 7.34817 13.8267 6.51076 12.9892M6.51076 12.9892C5.67334 12.1518 5.30415 10.9992 5.38519 9.81966C5.46623 8.64007 5.9975 7.42446 6.96098 6.46098C7.92446 5.4975 9.14007 4.96623 10.3197 4.88519C11.4992 4.80415 12.6518 5.17334 13.4892 6.01076M6.51076 12.9892C5.67334 12.1518 4.52076 11.7826 3.34117 11.8637C2.54877 11.9177 1.73837 12.1788 1 12.6381M6.51076 12.9892C7.34817 13.8267 8.50075 14.1958 9.68034 14.1148C10.8599 14.0338 12.0755 13.5025 13.039 12.539C14.0025 11.5755 14.5338 10.3599 14.6148 9.18034C14.6958 8.00075 14.3267 6.84817 13.4892 6.01076M13.4892 6.01076C14.3267 6.84817 15.4792 7.21736 16.6588 7.13632C17.4512 7.08229 18.2616 6.82116 19 6.36193M13.4892 6.01076C12.6518 5.17334 12.2826 4.02076 12.3637 2.84117C12.4177 2.04877 12.6788 1.23837 13.1381 0.5M7.87044 7.37944L12.1206 11.6296M6.96098 8.9012L10.6078 12.548M6.51076 10.8822L8.63582 13.0073M3.92646 13.1603L6.35768 15.5915M9.3922 6.47899L13.039 10.1258M11.3732 6.02876L13.4982 8.15383M13.6513 3.44447L16.0825 5.87569",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnaVisitTypeIconTable);
export default __webpack_public_path__ + "static/media/dnaVisitTypeIconTable.83242bf431442e62ec89e7fff90a6a92.svg";
export { ForwardRef as ReactComponent };